// extracted by mini-css-extract-plugin
export default {"container":"style_container__tUwBC","logo":"style_logo__MQb1s","text":"style_text__yt5cd","textButton":"style_textButton__e0kBt"};